import { SvgWeb } from "@web-app/public/images/svg/SvgWeb";

type Props = {
  svgName: string;
  url: string;
};

const SocialMedia = ({ svgName, url }: Props) => {
  return (
    <div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={svgName}
      >
        <SvgWeb name={svgName} alt={svgName} width={24} height={24} />
      </a>
    </div>
  );
};

export default SocialMedia;
